import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { FFTableHeadProps } from './types';
import { useFFTableStyles } from './styles';

export function FFTableHead<T>({
  columns,
  order,
  orderBy,
  onRequestSort,
  serverSide = false,
  hasExpandableRows = false,
}: FFTableHeadProps<T>) {
  const classes = useFFTableStyles();

  const createSortHandler = (property: string) => () => {
    onRequestSort(property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* Add an empty cell for the expand icon column if rows are expandable */}
        {hasExpandableRows && (
          <TableCell
            className={classes.tableCellHeader}
            style={{ width: 50, minWidth: 50, maxWidth: 50, padding: 0 }}
          />
        )}

        {columns.filter((column) => !column.hide).map((column) => (
          <TableCell
            key={column.id}
            align={column.align || 'left'}
            style={{
              minWidth: column.minWidth,
              width: column.width,
            }}
            className={classes.tableCellHeader}
          >
            {column.sortable ? (
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : 'asc'}
                onClick={createSortHandler(String(column.id))}
              >
                {column.label}
                {orderBy === column.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              column.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default FFTableHead;
